export const INPUTS = {
    annualIncome: 'annualIncome',
    monthlyDebts: 'monthlyDebts',
    downPayment: 'downPayment',
    creditScore: 'creditScore',
    cityOrZip: 'cityOrZip',
    zipCode: 'zipCode',
    city: 'city',
    state: 'state',
};

export const OUTCOME = {
    ZHL_PREQUAL: 'ZHL_PREQUAL',
    ZGMI_CQ: 'ZGMI_CQ',
    LOW_CREDIT: 'LOW_CREDIT',
    HIGH_DEBT: 'HIGH_DEBT',
};

export const ENV = {
    dev: 'dev',
    prod: 'prod',
};

export const CONFIGS = {
    [ENV.dev]: {
        partnerId: 'RD-XZQQPCN',
        autocompleteBaseUrl: 'https://zillowstatic.com/autocomplete', // using prod because QA env has CORS issues
        maxBaseUrl: 'https://mortgageapi.qa.zillow.net',
        zillowBaseUrl: 'https://www.qa.zillow.net',
        zhlBaseUrl: 'https://www.dev.zillowhomeloans.net',
    },
    [ENV.prod]: {
        partnerId: 'RD-CZMBMCZ',
        autocompleteBaseUrl: 'https://zillowstatic.com/autocomplete',
        maxBaseUrl: 'https://mortgageapi.zillow.com',
        zillowBaseUrl: 'https://www.zillow.com',
        zhlBaseUrl: 'https://www.zillowhomeloans.com',
    },
};
